// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2CyJu","amount":"Amount_amount__M59op","tip":"Amount_tip__Cj5sF","tipHeader":"Amount_tipHeader__1kcun","tipsWrap":"Amount_tipsWrap__3agc1"};